import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface TerciaryButtonProps {
  label: string;
  colour: "black" | "red";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
  dataTestid?: string;
  type?: "button" | "submit" | "reset";
  iconClassName?: string;
}

const TerciaryButton = ({
  label,
  colour = "red",
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  width,
  dataTestid,
  type,
  iconClassName,
}: TerciaryButtonProps) => {
  return (
    <Button
      dataTestid={dataTestid}
      label={label}
      size={size}
      type={`terciary-${colour}`}
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
      buttonType={type}
      iconClassName={iconClassName}
    />
  );
};

export default memo(TerciaryButton);
